<svg
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	xml:space="preserve"
	style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;"
>
	<g id="Group_8106" transform="matrix(1,0,0,1,-1995,-413)">
		<g id="Ellipse_1220" transform="matrix(1,0,0,1,1995,413)">
			<circle cx="12" cy="12" r="12" style="fill:rgb(148,163,184);fill-opacity:0.2;" />
		</g>
		<g id="Ellipse_1221" transform="matrix(1,0,0,1,2000,418)">
			<circle cx="7" cy="7" r="7" style="fill:rgb(148,163,184);fill-opacity:0.5;" />
		</g>
		<g transform="matrix(0.999984,0.00569827,-0.00569827,0.999984,1995.08,412.847)">
			<g id="Path_7134">
				<path d="M12,16L12,12" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;" />
			</g>
		</g>
		<g id="Path_7135" transform="matrix(1,0,0,1,1995,413.8)">
			<path d="M12,8L12.01,8" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;" />
		</g>
	</g>
</svg>
